var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_659_3266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#EBDFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2256 5.75844L25.0981 6.5951L25.0781 4.33594L28.2256 5.75844Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1289 7.88184C24.5096 7.88184 25.6289 6.76255 25.6289 5.38184C25.6289 4.00112 24.5096 2.88184 23.1289 2.88184C21.7482 2.88184 20.6289 4.00112 20.6289 5.38184C20.6289 6.76255 21.7482 7.88184 23.1289 7.88184Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8994 9.61849C24.8994 11.4593 22.7494 12.7993 20.1077 12.9518C14.6911 13.2643 13.9619 7.95182 13.9619 7.95182C13.9619 7.95182 17.4611 6.28516 20.1077 6.28516C22.7544 6.28516 24.8994 7.77766 24.8994 9.61849Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4971 8.78516C16.4971 8.88932 17.9846 10.4985 19.8654 10.6952C22.8512 11.0077 23.7546 9.20182 23.7546 9.20182C23.7546 9.20182 23.5621 11.9127 19.6571 11.3202C16.9137 10.9027 16.4971 8.78516 16.4971 8.78516Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6909 12.2568H18.6143V15.5552H19.6909V12.2568Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3003 12.3267H20.2236V15.625H21.3003V12.3267Z",
    fill: "#00A2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6253 21.3027L28.0545 18.9468C27.2887 18.7585 26.7087 18.1318 26.5803 17.3535L26.3412 15.9035L17.7778 14.8185C15.2328 14.496 12.7912 15.9302 11.8328 18.3102L5.57617 33.846C9.21534 37.6368 14.3303 40.0002 20.0003 40.0002C22.402 40.0002 24.7045 39.576 26.8387 38.7993L25.4228 32.6202C25.182 31.5668 25.752 30.4968 26.7603 30.1102L33.2978 27.5993C35.9045 26.5985 37.6253 24.0943 37.6253 21.3027Z",
    fill: "#B7876C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9169 17.8127C13.1461 18.7502 15.0211 21.3194 12.2086 25.7986C10.2794 28.8711 9.83112 32.8044 14.3961 33.2294C23.3544 34.0627 20.1169 23.4686 18.9794 20.6252C18.3544 19.0627 16.6753 16.8819 14.9169 17.8127Z",
    fill: "#845B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6789 23.5417H36.9456C37.5214 23.5417 38.0373 23.1459 38.1514 22.5817C38.1531 22.5742 38.1548 22.5667 38.1556 22.5592C38.2898 21.8825 37.8723 21.2184 37.1964 21.0809L34.4473 20.52V22.31C34.4473 22.99 34.9989 23.5417 35.6789 23.5417Z",
    fill: "#845B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5244 20.1567L25.1677 19.2492C25.7677 19.1317 26.2011 18.6059 26.2011 17.9942C26.2011 17.0259 25.1661 16.4092 24.3144 16.8692L21.6144 18.3276C20.9436 18.6909 20.5244 19.3934 20.5244 20.1567Z",
    fill: "#845B31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_659_3266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.ae29fe047ef9626c9ddd0bfc39f87d71.svg";
export { ForwardRef as ReactComponent };